/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import breakpoints from '../../utils/constants/breakpoints'

const Video = ({ src, path, width, maxHeight, hideOnSmall, alt, frameColor, dashedFrame, blur, grayscale, sepia }) => {
  if (!src && !path) return false
  const style = css`
    display: block;
    max-width: ${width || '100%'};
    ${maxHeight ? `max-height: ${maxHeight};` : ''}
    ${frameColor &&
    `
			border: solid 2px ${frameColor};
			border-radius: 5px;
		`}
		${dashedFrame ? `border-style: dotted;` : ''}

		@media (max-width: ${breakpoints.md}px) {
      ${hideOnSmall ? 'display: none' : ''}
    }
  `

  return <video css={style} alt={alt || src || path} src={src || path} controls autoPlay />
}

export default Video
